const VIDEOTYPES = [
    "3g2",
    "3gp",
    "amv",
    "asf",
    "avi",
    "drc",
    "flv",
    "f4v",
    "f4p",
    "f4a",
    "f4b",
    "gifv",
    "m4v",
    "mkv",
    "mng",
    "mov",
    "qt",
    "mp4",
    "m4p",
    "m4v",
    "mpg",
    "mp2",
    "mpeg",
    "mpe",
    "mpv",
    "mpg",
    "mpeg",
    "m2v",
    "mts",
    "m2ts",
    "ts",
    "mxf",
    "nsv",
    "ogv",
    "ogg",
    "rm",
    "rmvb",
    "roq",
    "svi",
    "viv",
    "vob",
    "webm",
    "wmv",
    "yuv",
];

const AUDIOTYPES = [
    "3gp",
    "aa",
    "aac",
    "aax",
    "act",
    "aiff",
    "amr",
    "ape",
    "au",
    "awb",
    "dss",
    "dvf",
    "flac",
    "gsm",
    "iklax",
    "ivs",
    "m4a",
    "m4b",
    "m4p",
    "mmf",
    "movpkg",
    "mp1",
    "mp2",
    "mp3",
    "mpc",
    "msv",
    "nmf",
    "ogg",
    "oga",
    "mogg",
    "opus",
    "ra",
    "rm",
    "raw",
    "rf64",
    "sln",
    "tta",
    "voc",
    "vox",
    "wav",
    "wma",
    "wv",
    "webm",
    "8svx",
    "cda",
]

const VOICEMAILTYPES = [
    "amr",
    "m4a",
    "wav"
]

const IMAGETYPES = [
"JPG",
"PNG",
"GIF",
"WEBP",
"TIFF",
"PSD",
"RAW",
"BMP",
"HEIF",
"INDD",
"jp2",
"jpx",
"jpf",
"j2k",
"j2c",
"jpm",
"mj2",
"mjp2",
"jph",
"SVG",
"AI",
"EPS",
]

const DOCTYPES = [
"pdf",
"doc",
"docx",
"dotx",
"dot",
"odt",
"ods",
"rtf",
"txt",
"xls",
"xlsx",
"csv",
"ppt",
"pptx",
"odp",
"html",
"htm",
"xml",
"xps",
"epub",
"vsd",
"vsdx",
"docm",
"dotm",
]


export const isVideo = (prm) => {
    const ext = prm.substring(prm.lastIndexOf('.') + 1, prm.length);
    if (VIDEOTYPES.includes(ext)) {
        return true;
    }
    return false;
}

export const isAudio = (prm) => {
    const ext = prm.substring(prm.lastIndexOf('.') + 1, prm.length);
    if (AUDIOTYPES.includes(ext)) {
        return true;
    }
    return false;
}

export const isVoicemail = (prm) => {
    const ext = prm.substring(prm.lastIndexOf('.') + 1, prm.length);
    if (VOICEMAILTYPES.includes(ext)) {
        return true;
    }
    return false;
}

export const isImage = (prm) => {
    const ext = prm.substring(prm.lastIndexOf('.') + 1, prm.length).toUpperCase();
    if (IMAGETYPES.includes(ext)) {
        return true;
    }
    return false;
}

export const isDoc = (prm) => {
    const ext = prm.substring(prm.lastIndexOf('.') + 1, prm.length);
    if (DOCTYPES.includes(ext)) {
        return true;
    }
    return false;
}